export default "<m-cylinder\n    color=\"yellow\"\n    y=\"2\"\n    radius=\"3\"\n    height=\"2\"\n></m-cylinder>\n";